//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import RegularMaintenanceDrawer from "./modules/RegularMaintenanceDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api'; // 站点树展示

import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin'; //人员类型

import { queryUserTreeList } from '@/api/api';
import { downloadFile } from '@api/manage';
export default {
  name: "RegularMaintenanceList",
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    RegularMaintenanceDrawer: RegularMaintenanceDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/regular/maintenance',
      pageTitle: '定期养护',
      userTree: [],
      //人员信息
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '养护人员',
        align: "center",
        sorter: false
      }, {
        dataIndex: 'frequency_dictText',
        colName: 'frequency',
        title: '养护频次',
        align: "center",
        sorter: false
      }, {
        dataIndex: 'lastTime',
        colName: 'last_time',
        title: '上次养护时间',
        align: "center",
        sorter: false
      }, {
        dataIndex: 'thisTime',
        colName: 'this_time',
        title: '本次养护时间',
        align: "center",
        sorter: false
      }, {
        dataIndex: 'remark',
        colName: 'remark',
        title: '备注',
        align: "center",
        sorter: false
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  //站点树监视
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  created: function created() {
    this.loadTreeList();
  },
  computed: {},
  methods: {
    handleEdit: function handleEdit(record) {
      this.$refs.modalForm.edit(record, true);
      this.$refs.modalForm.title = '编辑：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = true;
    },
    handleExportXls: function handleExportXls(fileName, recordId) {
      var url = this.pagePath + '/exportXls';
      downloadFile(fileName + '.xls', url, {
        id: recordId
      });
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    onDateLastTime: function onDateLastTime(value, dateArray) {
      this.queryParam.lastTimeStart = dateArray[0];
      this.queryParam.lastTimeEnd = dateArray[1];
    },
    onDateThisTime: function onDateThisTime(value, dateArray) {
      this.queryParam.thisTimeStart = dateArray[0];
      this.queryParam.thisTimeEnd = dateArray[1];
    }
  }
};